import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "onDismiss", "size", "className"];
import { clsx } from 'clsx';
import { DialogBase } from "../DialogBase";

// ============================= Pre header commponent =====================//
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Use this component to put some content like icons or other component.
 */
export var PreHeader = function PreHeader(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx("div", {
    className: "tw-min-h-5.6 tw-w-full tw-flex tw-justify-center tw-mb-1.6 tw-mt-2.5",
    children: children
  });
};

// ========================== Title ================================= //

export var Title = function Title(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_jsx("div", {
    className: "tw-font-h5 tw-font-semibold tw-text-center dark:tw-text-neutral-light-100",
    children: children
  });
};

// ========================== Description ========================== //

export var Description = function Description(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/_jsx("div", {
    className: "tw-font-body4 tw-pt-1.2 tw-pb-2.4 tw-text-center dark:tw-text-neutral-light-100",
    children: children
  });
};

// =========================== Actions =========================== //

export var Actions = function Actions(_ref4) {
  var children = _ref4.children,
    className = _ref4.className;
  return /*#__PURE__*/_jsx("div", {
    className: clsx('tw-pt-2 tw-flex tw-items-center tw-justify-center tw-gap-0.8', className),
    children: children
  });
};

// ============================= Main Component ====================== //

export var DialogInformative = function DialogInformative(_ref5) {
  var children = _ref5.children,
    onDismiss = _ref5.onDismiss,
    size = _ref5.size,
    className = _ref5.className,
    rest = _objectWithoutProperties(_ref5, _excluded);
  return /*#__PURE__*/_jsx(DialogBase, _objectSpread(_objectSpread({}, rest), {}, {
    onDismiss: onDismiss,
    onEscape: onDismiss,
    className: className,
    children: /*#__PURE__*/_jsx("div", {
      className: clsx({
        'tw-w-full sm:tw-w-[56.4rem]': size === 's',
        'tw-w-[76rem]': size === 'm',
        'tw-pt-2.4 tw-px-2.4 tw-pb-2': !(className !== null && className !== void 0 && className.includes('tw-p'))
      }),
      children: children
    })
  }));
};
DialogInformative.PreHeader = PreHeader;
DialogInformative.Title = Title;
DialogInformative.Description = Description;
DialogInformative.Actions = Actions;
export default DialogInformative;